/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionNetworksPagedList } from '../../models/subscription-networks-paged-list';

export interface GetNetworksOfSubscription$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;
}

export function getNetworksOfSubscription(http: HttpClient, rootUrl: string, params: GetNetworksOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionNetworksPagedList>> {
  const rb = new RequestBuilder(rootUrl, getNetworksOfSubscription.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionNetworksPagedList>;
    })
  );
}

getNetworksOfSubscription.PATH = '/subscriptions/{uid}/networks';
